import {useState, useRef, useEffect} from 'react';
import ReactCountryFlag from "react-country-flag"

export default function About() {

    const [uiLang, setUiLang] = useState("");
    const [isShownEng, setIsShownEng] = useState(uiLang === 'EN' ? true : false);
    const [isShownNL, setIsShownNL] = useState(uiLang === 'NL' ? true : false);

    const isFirstUpdate = useRef(true);

    useEffect(() => {
        if (isFirstUpdate.current) {
            let lang = getFirstBrowserLang();

            if(lang==='en-GB' || lang==='en-US'){
                setIsShownEng(true);
                setIsShownNL(false);
                setUiLang("EN");
            }else if(lang==='en-NL' || lang==='nl-NL'){
                setIsShownNL(true);
                setIsShownEng(false);
                setUiLang("NL");
            }

            isFirstUpdate.current = false;
            return;
        }

    }, [uiLang]);


    const handleChange = (e) => {
        console.log(e.target.value);
        setIsShownEng(current => !current);
        setIsShownNL(current => !current);
        setUiLang( e.target.value);
    }

    const getFirstBrowserLang = () => {
        let nav = window.navigator,
            browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
            i,
            language;

        // support for HTML 5.1 "navigator.languages"
        if (Array.isArray(nav.languages)) {
            for (i = 0; i < nav.languages.length; i++) {
                language = nav.languages[i];
                if (language && language.length) {
                    return language;
                }
            }
        }

        // support for other well known properties in browsers
        for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
            language = nav[browserLanguagePropertyKeys[i]];
            if (language && language.length) {
                return language;
            }
        }

        return null;
    }
    return (
        <div>
            <div id="languages">
                <div id="langSelect">
                    <span>Select:</span>
                    <select onChange={handleChange}>
                        <option value="EN">English</option>
                        <option value="NL">Dutch</option>
                    </select>
                </div>
                <div id="flags">
                    {isShownEng && <ReactCountryFlag
                        className="emojiFlag"
                        countryCode="GB"
                        style={{
                            margin: 0,
                            fontSize: '2em',
                            lineHeight: '0em',
                        }}
                        aria-label="English"
                    />}
                    {isShownNL && <ReactCountryFlag
                        className="emojiFlag"
                        countryCode="NL"
                        style={{
                            margin: 0,
                            fontSize: '2em',
                            lineHeight: '0em',
                        }}
                        aria-label="Dutch"
                    />}
                </div>
            </div>

            {isShownEng && <div id="about" className="english">
                <h4>Hi! I am Trix Mostert</h4>
                <p>I am a Full Stack Software Developer and I work mainly in React (Javascript), HTML and CSS.</p>
                <p>I have nearly 10years of mixed experience with CMS and E-commerce platforms and most recently with Shopify</p>
                <p>I can create a beautiful e-Commerce website for you at an affordable rate.</p>
                <p>Let's connect today!</p>
            </div>}
            {isShownNL && <div id="about" className="dutch">
                <h4>Hoi! Ik ben Trix Mostert</h4>
                <p>Ik ben front end developer en ik gebruik React (Javascript), HTML and CSS.</p>
                <p>Ik werk al bijna 10 jaar met CMS and E-commerce platforms en het meest recent ook met Shopify</p>
                <p>Ik kan voor u een e-Commerce website bouwen tegen een tarief die u u kunt veroorloven.</p>
                <p>Maak vandaag een afspraak - ik wil u graag spreken:</p>
            </div>}
        </div>
    );
}
